export const getMaxDisplayDecimals = (decimals: number, limit: number = 6) => {
  return Math.min(decimals, limit);
};
